/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum Action {
  REMOVE = "remove",
  EDIT = "edit",
  CREATE = "create",
}
